import { getBookIdWithPrefix, getFirstTitleChar } from "@/shared/utils/content/content";
import { BOOK_PERMISSION, BOOK_TYPES } from "@/shared/utils/content/content.constants";

export const convertAbbreviation = (abbr) => {
  const chars = [];
  abbr.abbreviations.forEach((string) => {
    chars.push(string.trim().substr(0, 1));
  });
  return {
    ...abbr,
    firstChars: chars,
  };
};

export const convertAbbreviations = (abbreviations) => {
  return {
    egw: abbreviations.egw.map((abbr) => convertAbbreviation(abbr)),
    bible: abbreviations.bible.map((abbr) => convertAbbreviation(abbr)),
  };
};

export const convertBooks = (books) => {
  return books.map(convertBook);
};

export const convertBook = (item) => {
  let firstChar = getFirstTitleChar(item.title);
  let realType = item.folder_color_group || item.subtype || item.type;
  if (BOOK_TYPES.indexOf(item.type) !== -1) {
    realType = item.type;
  }

  const isForSale = item.permission_required === BOOK_PERMISSION.purchased;
  const {
    cover,
    ...otherBookProps
  } = item;
  const bookData = {
    ...otherBookProps,
    realType,
    label: item.title,
    className: "book",
    id: getBookIdWithPrefix(item.book_id),
    pubYear: parseInt(otherBookProps.pub_year) || 0,
    firstChar,
    isForSale,
  };
  if (cover) {
    if (cover.small) {
      bookData.coverSmall = cover.small;
    }
    if (cover.large) {
      bookData.coverLarge = cover.large;
    }
  }

  return bookData;
};
